

import React, { useCallback, useEffect, useState} from 'react';
import { Card, CardContent, Typography, Box, Divider } from '@mui/material';
import { useWasteManagement, WasteManagementType } from '../../../ContextAPI/WasteManagementContext';
import { FetchWasteCardReport } from '../../../ApiServices/ApiRequests';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { BinOverviewReportCard } from '../../../Models/Models';
import { useMasterData } from '../../../ContextAPI/MasterContext';
import Loading from '../../../Controller/LoadingController/Loading';


const WasteMonitoringCard: React.FC = () => {
  const { masterState } = useMasterData();

  const { wasteManagementState, dispatchWasteManagement } =
    useWasteManagement();
    const {t}= useTranslation()
  const[loading,setLoading]=useState<boolean>(false)
    const handleBulkUpdate = useCallback(
      (value: Partial<WasteManagementType>) => {
        dispatchWasteManagement({ type: "BULK_UPDATE", value });
      },
      [dispatchWasteManagement]
    );
  
  
    const fetchData = async (
      siteCode: string,
      fromDate: string,
      groupId: string
    ): Promise<void> => {
      try {
        setLoading(true)
        const data: BinOverviewReportCard = await FetchWasteCardReport(
          siteCode,
          fromDate,
          groupId
        );
        // Check if data.content has entries, and if so, process the report data
        const reportData =
          data && data
            ? {
                totalWasteMoniterValue: data.totalValue,
                totalWasteValueChanges: data.totalValueChanges,
                totalWasteValueColor: data.totalValueColor,
                averageFillWastelabel: data.avgValue,
                avgWasteValueChanges: data.avgValueChanges,
                avgWasteValueColor: data?.avgValueColor,

                // Ensure siteData is an empty array if report is undefined
              }
            : {
                totalWasteMoniterValue: 0,
                totalWasteValueChanges: "",
                totalWasteValueColor: "",
                averageFillWastelabel: 0,
                avgWasteValueChanges: "",
                avgWasteValueColor: "",
                // Set siteData as an empty array if content is empty
              };

        // Dispatch the data with handleBulkUpdate
        handleBulkUpdate(reportData);
      } catch (error) {}
      finally{
        setLoading(false)
      }
    };
    
  
    useEffect(() => {
      const formattedDate: string = masterState.reportSelectedDate
        ? masterState.reportSelectedDate.format("YYYY-MM-DD")
        : "";
      
      if(masterState.selectedSiteCode.length>0 ){
      fetchData(masterState.selectedSiteCode,
        formattedDate ,masterState.selectedGroupCode);
      }
    }, [masterState.selectedSiteCode,masterState.selectedGroupCode,masterState.reportSelectedDate]);
  

  return (
    <>
      {loading ? (
        <Loading loading={loading} type={`dots`} backDrop={false} />
      ) : (
    <Box display="flex" gap={2} bgcolor={"#f9f9f9"} p={1} mt={2}>
      <Card sx={{ display: 'flex', borderLeft: '4px solid #8850ef', minWidth: 250,ml:3,maxHeight:130}}>
        <CardContent>
          <Typography color="textSecondary" gutterBottom>
          {t ("global.TotalWasteCollected")}
          </Typography>
          <Typography variant="h5">
             { wasteManagementState.totalWasteMoniterValue?? 0} 
          </Typography>
          <Typography color={wasteManagementState.totalWasteValueColor}>
            {wasteManagementState.totalWasteValueChanges ?? 0}
          </Typography>
        </CardContent>
      </Card>
      
      <Card sx={{ display: 'flex', borderLeft: '4px solid #8850ef', minWidth: 250,maxHeight:130 }}>
        <CardContent>
          <Typography color="textSecondary" gutterBottom>
          {t ("global.AverageCollectionTime")}
          </Typography>
          <Typography variant="h5">
            {wasteManagementState.averageFillWastelabel?  wasteManagementState.averageFillWastelabel : 0}
          </Typography>
          <Typography color={wasteManagementState.avgWasteValueColor}>
            {wasteManagementState.avgWasteValueChanges??0 }
          </Typography>
        </CardContent>
      </Card>
    </Box>
      )}
    </>
  );
};

export default WasteMonitoringCard;
